module.exports = __webpack_public_path__ + "static/media/Wildcat Territory_2c.e2653873.svg";